import React from 'react';

import hbg from '../../images/slider/slide-9.jpg'
import slide9 from '../../images/slider/slide-9-1.jpg'

const Hero9 = () => {
    return (
        <section className="wpo-hero-static-s7">
            <div className="content">
                <h2 className="fade_bottom">Timeless</h2>
                <h3 className="fade_bottom">Furniture,</h3>
                <p className="fade_bottom">Furnishing Your Dreams,
                    One Piece at a Time</p>
                <h4 className="fade_bottom">Modern Living</h4>
            </div>
            <div className="bg-img">
                <img src={hbg} alt="" />
            </div>
            <div className="rigth-image">
                <img src={slide9} alt="" />
            </div>
        </section>
    );
};

export default Hero9;